var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',_vm._g({attrs:{"src":_vm.currentSrc},on:{"error":_vm.handleError},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_vm._t("placeholder",function(){return [_c('div',{staticStyle:{"width":"100%","height":"100%"}})]})]},proxy:true}],null,true)},_vm.cleanListeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }